const FranchisePage = function () {
  function FranchisePage() {
    this.selector = {
      storeslider: document.querySelectorAll('.franchise-store-slider'),
      featuredslider: document.querySelectorAll('.franchise-featured-slider'),
      featuredvideo: document.querySelectorAll('.franchise-featured-video'),
      award: document.querySelectorAll('.franchise-section-award'),
      recruitement: document.querySelectorAll('.franchise-section-recruitment'),
      steps: document.querySelectorAll('.franchise-section-recruitment .step'),
      videoplay: document.querySelectorAll('.franchise-featured-video .video .image .video-play'),
      videobox: document.querySelector('.popup-box-video'),
      videoboxclose: document.querySelector('.popup-box-video .close'),
      slidetiles: document.querySelectorAll('.slide-tiles .grid-tiles'),
      slidecolumns: document.querySelectorAll('.slide-columns'),
      textwithslider: document.querySelectorAll('.section-text-with-slider'),
      featuredarticles: document.querySelectorAll('.franchise-featured-articles'),
    };
    this.state = {
      running: false,
    };
    this.load();
  }
  FranchisePage.prototype.load = function () {
    var _ = this;
    if (_.selector.featuredslider.length > 0) {
      _.selector.featuredslider.forEach((el) => {
        $(el.dataset.selectorName).slick({
          dots: document.querySelectorAll(`${el.dataset.selectorName} .slide`).length > 3,
          arrows: true,
          infinite: true,
          autoplay: true,
          lazyLoad: 'progressive',
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .slide`).length > 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .slide`).length > 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .slide`).length > 1,
              },
            },
          ],
          prevArrow:
            '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
          nextArrow:
            '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
        });
      });
    }
    if (_.selector.storeslider.length > 0) {
      _.selector.storeslider.forEach((el) => {
        $(el.dataset.selectorName).slick({
          dots: document.querySelectorAll(`${el.dataset.selectorName} .slide`).length > 1,
          arrows: true,
          infinite: true,
          autoplay: false,
          lazyLoad: 'progressive',
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .slide`).length > 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .slide`).length > 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .slide`).length > 1,
              },
            },
          ],
          prevArrow:
            '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
          nextArrow:
            '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
        });
      });
    }
    if (_.selector.featuredvideo.length > 0) {
      _.selector.featuredvideo.forEach((el) => {
        $(el.dataset.selectorName).slick({
          dots: document.querySelectorAll(`${el.dataset.selectorName} .video`).length > 3,
          arrows: true,
          infinite: true,
          autoplay: false,
          lazyLoad: 'progressive',
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '50px',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .video`).length > 3,
                centerMode: true,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: false,
                arrows: false,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .video`).length > 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                arrows: false,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .video`).length > 1,
              },
            },
          ],
          prevArrow:
            '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
          nextArrow:
            '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
        });
      });
    }
    if (_.selector.award.length > 0) {
      _.selector.award.forEach((el) => {
        $(el.dataset.selectorName).slick({
          dots: document.querySelectorAll(`${el.dataset.selectorName} .award`).length > 4,
          arrows: true,
          infinite: true,
          autoplay: false,
          lazyLoad: 'progressive',
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '50px',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .award`).length > 3,
                centerMode: true,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: false,
                arrows: false,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .award`).length > 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                arrows: false,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .award`).length > 1,
              },
            },
          ],
          prevArrow:
            '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
          nextArrow:
            '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
        });
      });
    }
    if (_.selector.steps.length > 0) {
      _.selector.steps.forEach((el) => {
        if (_.elementisvisible(el)) {
          if (!el.classList.contains('active')) {
            _.recruitementstart();
          }
        }
      });
    }
    window.onscroll = () => {
      if (_.selector.steps.length > 0) {
        _.selector.steps.forEach((el) => {
          if (_.elementisvisible(el)) {
            if (!el.classList.contains('active')) {
              _.recruitementstart();
            }
          }
        });
      }
    };
    if (_.selector.videoplay.length > 0) {
      _.selector.videoplay.forEach((btn) => {
        btn.addEventListener('click', (event) => {
          const template = event.target.closest('.video').querySelector('template');
          const clone = document.importNode(template.content, true);
          _.selector.videobox.querySelector('.content').appendChild(clone);
          _.selector.videobox.classList.add('active');
        });
      });
    }
    if (_.selector.videoboxclose) {
      _.selector.videoboxclose.addEventListener('click', () => {
        _.selector.videobox.querySelector('.content').innerHTML = '';
        _.selector.videobox.classList.remove('active');
      });
    }
    if ($(window).width() < 768) {
      if (_.selector.slidetiles.length > 0) {
        _.selector.slidetiles.forEach((el) => {
          if (!el.classList.contains('slick-initialized')) {
            $(el.dataset.selectorName).slick({
              dots: document.querySelectorAll(`${el.dataset.selectorName} .tile`).length > 1,
              arrows: false,
              infinite: true,
              autoplay: false,
              lazyLoad: 'progressive',
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false,
              centerPadding: '50px',
              prevArrow:
                '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
              nextArrow:
                '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
            });
          }
        });
      }
      if (_.selector.slidecolumns.length > 0) {
        _.selector.slidecolumns.forEach((el) => {
          if (!el.classList.contains('slick-initialized')) {
            $(el.dataset.selectorName).slick({
              dots: document.querySelectorAll(`${el.dataset.selectorName} .column`).length > 1,
              arrows: false,
              infinite: true,
              autoplay: true,
              lazyLoad: 'progressive',
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false,
            });
          }
        });
      }
    }
    $(window).resize(function () {
      if ($(window).width() < 768) {
        if (_.selector.slidetiles.length > 0) {
          _.selector.slidetiles.forEach((el) => {
            if (!el.classList.contains('slick-initialized')) {
              $(el.dataset.selectorName).slick({
                dots: document.querySelectorAll(`${el.dataset.selectorName} .tile`).length > 1,
                arrows: false,
                infinite: true,
                autoplay: false,
                lazyLoad: 'progressive',
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: '50px',
                prevArrow:
                  '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
                nextArrow:
                  '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
              });
            }
          });
        }
        if (_.selector.slidecolumns.length > 0) {
          _.selector.slidecolumns.forEach((el) => {
            if (!el.classList.contains('slick-initialized')) {
              $(el.dataset.selectorName).slick({
                dots: document.querySelectorAll(`${el.dataset.selectorName} .column`).length > 1,
                arrows: false,
                infinite: true,
                autoplay: true,
                lazyLoad: 'progressive',
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
              });
            }
          });
        }
      } else {
        if (_.selector.slidetiles.length > 0) {
          _.selector.slidetiles.forEach((el) => {
            if (el.classList.contains('slick-initialized')) {
              $(el.dataset.selectorName).slick('unslick');
            }
          });
        }
        if (_.selector.slidecolumns.length > 0) {
          _.selector.slidecolumns.forEach((el) => {
            if (el.classList.contains('slick-initialized')) {
              $(el.dataset.selectorName).slick('unslick');
            }
          });
        }
      }
    });
    if (_.selector.textwithslider.length > 0) {
      _.selector.textwithslider.forEach((el) => {
        $(el.dataset.selectorName).slick({
          dots: document.querySelectorAll(`${el.dataset.selectorName} .slide`).length > 1,
          arrows: false,
          infinite: true,
          autoplay: false,
          lazyLoad: 'progressive',
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          prevArrow:
            '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
          nextArrow:
            '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
        });
      });
    }
    if (_.selector.featuredarticles.length > 0) {
      _.selector.featuredarticles.forEach((el) => {
        $(el.dataset.selectorName).slick({
          dots: document.querySelectorAll(`${el.dataset.selectorName} .slide`).length > 3,
          arrows: true,
          infinite: true,
          autoplay: true,
          lazyLoad: 'progressive',
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .slide`).length > 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .slide`).length > 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: document.querySelectorAll(`${el.dataset.selectorName} .slide`).length > 1,
              },
            },
          ],
          prevArrow:
            '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
          nextArrow:
            '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#f47623" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
        });
      });
    }
  };
  FranchisePage.prototype.sleep = function (ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };
  FranchisePage.prototype.elementisvisible = function (el, partiallyVisible = false) {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return partiallyVisible
      ? ((top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) &&
          ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
      : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
  };
  FranchisePage.prototype.recruitementstart = async function () {
    var _ = this;
    if (_.selector.steps.length > 0) {
      for (const [index, el] of _.selector.steps.entries()) {
        el.classList.add('active');
        await _.sleep(500);
      }
    }
  };
  FranchisePage = new FranchisePage();
};
FranchisePage();
